<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<form [formGroup]="form">

  <input type="hidden" id="memNo" formControlName="memNo" />
  <input type="hidden" id="birthType" formControlName="birthType" />

  <div class="inner-wrap">

    <ng-container *ngIf="(memberInfo$ | async)['level'] > 2">
      <div class="join-input-company mb30">
        <div class="page-title">유료기간 정보</div>

        <table>
        <colgroup>
          <col class="th-title" />
          <col />
        </colgroup>

        <tbody>
        <tr>
          <th scope="row">유료회원 기간</th>
          <td>
            <!-- 기간이 남은 경우 //-->
            <span>
              <input type="text" id="effectiveSdate" formControlName="effectiveSdate" class="ro w200p" readonly="true" placeholder="유료기간 시작일" />
              <span class="ml10 mr10">~</span>
              <input type="text" id="effectiveEdate" formControlName="effectiveEdate" class="ro w200p" readonly="true" placeholder="유료기간 종료일" />
            </span>

            <!-- 유료 기간이 지난 경우 //-->
            <span *ngIf="this.manager.expire" class="paid-expire">
              <a [routerLink]="'/member/mypage/paidmember/step1'" class="btn btn-default ml20">유료기간 연장</a>
            </span>
          </td>
        </tr>
        </tbody>
        </table>
      </div>
    </ng-container>

    <div *ngIf="form.controls.companySeq.value === null" class="join-input">
      <div class="info">*필수입력입니다.</div>
      <a routerLink="/contents" [queryParams]="{menu_seq:248}" class="link-btn">유료·무료 서비스 안내</a>

      <input type="hidden" id="comJob" formControlName="comJob" />

      <table>
      <colgroup>
        <col class="th-title">
        <col>
      </colgroup>

      <tbody>
      <tr>
        <th><span class="necessary">*</span>아이디</th>
        <td><input type="text" id="userId" formControlName="userId" class="ro" readonly="true" /></td>
      </tr>
      <tr>
        <th>비밀번호</th>
        <td>
          <input type="password" id="password" formControlName="password" [ngClass]="{formErrors:formErrors['password']}" placeholder="비밀번호 (6~20자의 영문 대소문자 및 숫자 조합)" />
          <span *ngIf="formErrors['password']" class="cred ml5">{{formErrors['password']}}</span>
        </td>
      </tr>
      <tr>
        <th>비밀번호 재입력</th>
        <td>
          <input type="password" id="passwordConfirm" formControlName="passwordConfirm" [ngClass]="{formErrors:formErrors['passwordConfirm']}" pattern="{{ this.form.get('password').value }}" />
          <span *ngIf="formErrors['passwordConfirm']" class="cred ml5">{{formErrors['passwordConfirm']}}</span>
        </td>
      </tr>
      <tr>
        <th><span class="necessary" >*</span>이름</th>
        <td><input type="text" id="userName" formControlName="userName" class="ro" readonly="true" /></td>
      </tr>
      <tr>
        <th><span class="necessary" >*</span>생년월일</th>
        <td><input type="text" id="birth" formControlName="birth" class="ro" readonly="true" /></td>
      </tr>
      <tr>
        <th>이름(영문명)</th>
        <td><input type="text" id="userEname" formControlName="userEname" /></td>
      </tr>
      <tr>
        <th>회사명</th>
        <td><input type="text" id="companyName" formControlName="companyName" /></td>
      </tr>
      <tr>
        <th>부서명</th>
        <td><input type="text" id="comDept" formControlName="comDept" /></td>
      </tr>
      <tr>
        <th><span class="necessary">*</span>이메일</th>
        <td>
          <input type="text" id="email" formControlName="email" [ngClass]="[formErrors['email'] ? 'formErrors' : '', formErrors['emailDupCheck'] ? 'formErrors' : '']" (keydown)="setEmailDupCheckInit()" />
          <button *ngIf="form.controls.emailDupCheck.value === false" class="btn1" (click)="checkEmailChangeDuplicate()">중복체크</button>
          <span *ngIf="formErrors['email']" class="cred ml5">{{formErrors['email']}}</span>
          <span *ngIf="formErrors['emailDupCheck']" class="cred ml5">이메일 중복체크을 하시기 바랍니다.</span>
          <input type="hidden" formControlName="emailDupCheck" pattern="{{ checkTrue }}" />
        </td>
      </tr>
      <tr>
        <th>자택전화</th>
        <td class="tel">
          <input type="text" id="telephone1" formControlName="telephone1" [ngClass]="{formErrors:formErrors['telephone1']}" />
          <span class="between">-</span>
          <input type="text" id="telephone2" formControlName="telephone2" [ngClass]="{formErrors:formErrors['telephone2']}" />
          <span class="between">-</span>
          <input type="text" id="telephone3" formControlName="telephone3" [ngClass]="{formErrors:formErrors['telephone3']}" />
          <span *ngIf="formErrors['telephone1'] || formErrors['telephone2'] || formErrors['telephone3']" class="cred ml5">{{ formErrors['telephone1'] ? formErrors['telephone1'] : ( formErrors['telephone2'] ? formErrors['telephone2'] : ( formErrors['telephone3'] ? formErrors['telephone3'] : '' ) ) }}</span>
        </td>
      </tr>
      <tr>
        <th>핸드폰</th>
        <td class="tel">
          <input type="text" id="mobile1" formControlName="mobile1" [ngClass]="{formErrors:formErrors['mobile1']}" />
          <span class="between">-</span>
          <input type="text" id="mobile2" formControlName="mobile2" [ngClass]="{formErrors:formErrors['mobile2']}" />
          <span class="between">-</span>
          <input type="text" id="mobile3" formControlName="mobile3" [ngClass]="{formErrors:formErrors['mobile3']}" />
          <span *ngIf="formErrors['mobile1'] || formErrors['mobile2'] || formErrors['mobile3']" class="cred ml5">{{ formErrors['mobile1'] ? formErrors['mobile1'] : ( formErrors['mobile2'] ? formErrors['mobile2'] : ( formErrors['mobile3'] ? formErrors['mobile3'] : '' ) ) }}</span>
        </td>
      </tr>
      <tr>
        <th>주소</th>
        <td>
          <div class="zipcode">
            <input type="text" id="zipcode" formControlName="zipcode" readonly="true" />
            <btn-daum-address (result)="setDaumAddressApi($event)" [options]="daumAddressOptions"></btn-daum-address>
          </div>
          <input type="text" class="addr1" id="address" formControlName="address" readonly="true" />
          <input type="text" class="addr2" id="addressDetail" formControlName="addressDetail" placeholder="나머지 주소를 입력해 주세요."/>
        </td>
      </tr>
      <tr>
        <th>SMS수신</th>
        <td>
          <div class="radio">
            <label>예
              <input type="radio" name="radio" id="smsCheckTrue" formControlName="smsCheck" name="smsCheck" [value]="true" />
              <span class="checkmark"></span>
            </label>
            <label>아니오
              <input type="radio" name="radio" id="smsCheckFalse" formControlName="smsCheck" name="smsCheck" [value]="false" />
              <span class="checkmark"></span>
            </label>
          </div>
        </td>
      </tr>
      <tr>
        <th>메일수신</th>
        <td>
          <div class="radio">
            <label>예
              <input type="radio" name="radio" id="emailCheckTrue" formControlName="emailCheck" name="emailCheck" [value]="true" />
              <span class="checkmark"></span>
            </label>
            <label>아니오
              <input type="radio" name="radio" id="emailCheckFalse" formControlName="emailCheck" name="emailCheck" [value]="false" />
              <span class="checkmark"></span>
            </label>
          </div>
        </td>
      </tr>
      </tbody>
      </table>

      <div class="btn-area">
        <a class="edit-btn cp" (click)="setMemberSave()">수정</a>
      </div>
    </div>

    <div *ngIf="form.controls.companySeq.value !== null" class="join-input-company">
      <div class="page-title">기업정보</div>

      <input type="hidden" id="userEname" formControlName="userEname" />
      <input type="hidden" id="birth" formControlName="birth" />
      <input type="hidden" id="telephone1" formControlName="telephone1" />
      <input type="hidden" id="telephone2" formControlName="telephone2" />
      <input type="hidden" id="telephone3" formControlName="telephone3" />
      <input type="hidden" id="companyName" formControlName="companyName" />
      <input type="hidden" id="zipcode" formControlName="zipcode" />
      <input type="hidden" id="address" formControlName="address" />
      <input type="hidden" id="addressDetail" formControlName="addressDetail" />

      <table class="mb50">
      <colgroup>
        <col class="th-title">
        <col>
      </colgroup>

      <tbody>
      <tr>
        <th><span class="necessary">*</span>기업명</th>
        <td><input type="text" class="ro" id="companySeqName" formControlName="companySeqName" readonly="true" /></td>
      </tr>
      <tr>
        <th><span class="necessary">*</span>사업자번호</th>
        <td><input type="text" class="ro" id="comNumber" formControlName="comNumber" readonly="true" /></td>
      </tr>
      </tbody>
      </table>

      <div class="page-title">기업아이디 정보</div>

      <div class="info">*필수입력입니다.</div>

      <table>
      <colgroup>
        <col class="th-title">
        <col>
      </colgroup>

      <tbody>
      <tr>
        <th><span class="necessary">*</span>아이디</th>
        <td><input type="text" id="userId" formControlName="userId" class="ro" readonly="true" /></td>
      </tr>
      <tr>
        <th>비밀번호</th>
        <td>
          <input type="password" id="password" formControlName="password" [ngClass]="{formErrors:formErrors['password']}" placeholder="비밀번호 (6~20자의 영문 대소문자 및 숫자 조합)" />
          <span *ngIf="formErrors['password']" class="cred ml5">{{formErrors['password']}}</span>
        </td>
      </tr>
      <tr>
        <th>비밀번호 재입력</th>
        <td>
          <input type="password" id="passwordConfirm" formControlName="passwordConfirm" [ngClass]="{formErrors:formErrors['passwordConfirm']}" pattern="{{ this.form.get('password').value }}" />
          <span *ngIf="formErrors['passwordConfirm']" class="cred ml5">{{formErrors['passwordConfirm']}}</span>
        </td>
      </tr>
      <tr>
        <th><span class="necessary" >*</span>이름</th>
        <td><input type="text" id="userName" formControlName="userName" class="ro" readonly="true" /></td>
      </tr>
      <tr>
        <th>부서명</th>
        <td><input type="text" id="comDept" formControlName="comDept" /></td>
      </tr>
      <tr>
        <th>담당업무</th>
        <td><input type="text" id="comJob" formControlName="comJob" /></td>
      </tr>
      <tr>
        <th><span class="necessary">*</span>핸드폰</th>
        <td class="tel">
          <input type="text" id="mobile1" formControlName="mobile1" [ngClass]="{formErrors:formErrors['mobile1']}" />
          <span class="between">-</span>
          <input type="text" id="mobile2" formControlName="mobile2" [ngClass]="{formErrors:formErrors['mobile2']}" />
          <span class="between">-</span>
          <input type="text" id="mobile3" formControlName="mobile3" [ngClass]="{formErrors:formErrors['mobile3']}" />
          <span *ngIf="formErrors['mobile1'] || formErrors['mobile2'] || formErrors['mobile3']" class="cred ml5">{{ formErrors['mobile1'] ? formErrors['mobile1'] : ( formErrors['mobile2'] ? formErrors['mobile2'] : ( formErrors['mobile3'] ? formErrors['mobile3'] : '' ) ) }}</span>
        </td>
      </tr>
      <tr>
        <th>이메일</th>
        <td><input type="text" id="email" formControlName="email" /></td>
      </tr>
      </tbody>
      </table>

      <div class="btn-area">
        <a class="btn1 edit-btn cp" (click)="setMemberSave()">수정</a>
      </div>


      <!-- 주담당자만 표시 //-->
      <ng-container *ngIf="manager.isMajor">
      <div class="mt50">
        <div class="page-title">기업아이디 관리</div>

        <!-- 관리자 시스템설정에 최대 갯수 있음 //-->
        <div class="info pt5">*기업아이디는 최대 {{this.manager.maxMemberCount}}개까지 등록가능합니다.</div>

        <div class="cb"></div>
      </div>

      <table class="hlist-table hlist-table1 mt0">
      <colgroup>
        <col style="width:10%;" />
        <col style="width:10%;" />
        <col style="width:10%;" />
        <col style="width:10%;" />
        <col style="width:10%;" />
        <col style="width:20%;" />
        <col style="width:10%;" />
        <col style="width:10%;" />
      </colgroup>

      <thead>
      <tr>
        <th scope="col">번호</th>
        <th scope="col">상태</th>
        <th scope="col">부서</th>
        <th scope="col">직위</th>
        <th scope="col">이름</th>
        <th scope="col">아이디</th>
        <th scope="col">신청일</th>
        <th scope="col">처리</th>
        <th scope="col">주 담당자 지정</th>
      </tr>
      </thead>

      <tbody>
      <tr *ngFor="let row of memberList; index as i">
        <td class="center">{{i + 1}}</td>
        <td class="center">{{row.approvalStatusName}}</td>
        <td class="center">{{row.deptName}}</td>
        <td class="center">{{row.jobName}}</td>
        <td class="center">{{row.userName}}</td>
        <td class="center">{{row.userId}}</td>
        <td class="center">{{row.joinDate}}</td>
        <td class="center">
          <ng-container *ngIf="row.approvalStatus === '1000'; else cancel">
            <div class="btn btn-primary btn-small ml5" (click)="setCompanyPersonApproval(row.memNo, true)">승인처리</div>
          </ng-container>
          <ng-template #cancel>
            <div class="btn btn-danger btn-small ml5" (click)="setCompanyPersonApproval(row.memNo, false)">승인취소</div>
          </ng-template>
        </td>
        <td class="center">
            <div *ngIf="row.approvalStatus !== '1000'" class="btn btn-info btn-small ml5" (click)="setCompanyMajor(row.memNo)" >주 담당자 지정</div>
        </td>
      </tr>
      </tbody>
      </table>
      </ng-container>

    </div>

  </div>

</form>

<app-footer></app-footer>
